'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INPUT_COMP_PROPS = exports.META_PROP = exports.META_KEYS = exports.META_SHAPE = exports.INPUT_PROP = exports.INPUT_KEYS = exports.INPUT_PROP_SHAPE = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var any = _propTypes2.default.any,
    bool = _propTypes2.default.bool,
    func = _propTypes2.default.func,
    shape = _propTypes2.default.shape,
    string = _propTypes2.default.string;
/* *****************************************************************************
  Redux Form(RF) field props: See Link for API document of redux-form-field
              http://redux-form.com/6.4.3/docs/api/Field.md/

  NOTE(JG): Even if we do not end up using redux-form we should consider
                  still adopting the below property structure.
*******************************************************************************/

var INPUT_PROP_SHAPE = exports.INPUT_PROP_SHAPE = {
  placeholder: string,
  checked: bool,
  name: string,
  onBlur: func,
  onChange: func,
  onDragStart: func,
  onDrop: func,
  onFocus: func,
  value: any
};
var INPUT_KEYS = exports.INPUT_KEYS = Object.keys(INPUT_PROP_SHAPE);
var INPUT_PROP = exports.INPUT_PROP = shape(INPUT_PROP_SHAPE);
/* ****************************** META Props **********************************
  Meta property is used for components to react to state of a component.
    NOTE(JG): Meta props are not passed to the base level react-native components
*/

var META_SHAPE = exports.META_SHAPE = {
  active: bool,
  autofilled: bool,
  asyncValidating: bool,
  dirty: bool,
  dispatch: func,
  error: string,
  warning: string,
  invalid: bool,
  pristine: bool,
  submitting: bool,
  submitFailed: bool,
  touched: bool,
  valid: bool,
  visited: bool
};
var META_KEYS = exports.META_KEYS = Object.keys(META_SHAPE);
var META_PROP = exports.META_PROP = shape(META_SHAPE);
var INPUT_COMP_PROPS = exports.INPUT_COMP_PROPS = {
  error: string,
  input: INPUT_PROP,
  inputComponent: func,
  meta: META_PROP,
  testID: string
};